import {RootStore} from './index';
import {makeAutoObservable, action} from "mobx"
import {IarBreadCrumbs} from "../interface/IarBreadCrumbs";

export class BasePageStore {
    private rootStore: RootStore | undefined;
    arBreadCrumbs: IarBreadCrumbs[] = [];
    title: string = '';

    constructor(rootStore?: RootStore) {
        makeAutoObservable(this);
        this.rootStore = rootStore;
    }

    @action
    setBreadCrumbs(arBreadCrumbs: IarBreadCrumbs[], init: string = 'main') {

        if (init === 'catalog') {
            this.arBreadCrumbs = [
                {url: '/', name: 'Главная'},
                {url: '/catalog', name: 'Каталог'}
            ];
        } else if (init === 'main') {
            this.arBreadCrumbs = [
                {url: '/', name: 'Главная'},
            ];
        }else if (init === 'brands'){
            this.arBreadCrumbs = [
                {url: '/', name: 'Главная'},
                {url: '/brands', name: 'Бренды'}
            ];
        }else {
            this.arBreadCrumbs = [];
        }
        for (let k in arBreadCrumbs) {
            this.arBreadCrumbs.push(arBreadCrumbs[k]);
        }
        return this;
    }

    @action
    setTitleInBreadCrumbs = () => {
        this.setTitle(this.arBreadCrumbs[this.arBreadCrumbs.length - 1].name);
    }

    @action
    setTitle(title: string) {
        this.title = title;
    }


    getTitle() {
        return this.title;
    }

    @action
    onClickBreadCrumbs = (el: IarBreadCrumbs, index: number) => {
        this.setTitle(el.name);
        this.arBreadCrumbs = this.arBreadCrumbs.splice(0, index);
    }

}